export const GET_CITIZENSHIP = 'GET_CITIZENSHIP'
export const GET_METRIC_SERIAL = 'GET_METRIC_SERIAL'
export const GET_METRIC_NUMBER = 'GET_METRIC_NUMBER'
export const GET_PUPIL_BIRTHDATE = 'GET_PUPIL_BIRTHDATE'
export const CLEAR_ALL = 'CLEAR_ALL'
